import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsLoadingFeedback, selectIsSendErrorFeedback } from '../../selectors';
import { sendFeedback } from '../../actions/feedback';
import { Form } from '../../components/Feedback/Form';
import { useFormValidator } from './utils';
import { trackFirstInteractionForm } from './tracking';
import { TThunkDispatch } from '../../types/redux';

export interface IFeedbackFormContainerState {
  name: string;
  phone: string;
  email: string;
  comment: string;
  nameError: boolean;
  phoneError: boolean;
  emailError: boolean;
  commentError: boolean;
}
export type TFeedbackFields = 'name' | 'phone' | 'email' | 'comment';

export const FeedbackFormContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isLoading = useSelector(selectIsLoadingFeedback);
  const isSendError = useSelector(selectIsSendErrorFeedback);
  const [state, setState] = React.useState<IFeedbackFormContainerState>({
    name: '',
    phone: '',
    email: '',
    comment: '',
    nameError: false,
    phoneError: false,
    emailError: false,
    commentError: false,
  });
  const [interacted, setInteracted] = React.useState(false);
  const formValidator = useFormValidator(state, setState);
  const setField = React.useCallback(
    (value: string, field: TFeedbackFields) => {
      setState({ ...state, [field]: value, [`${field}Error`]: false });

      // Отправка события "первое взаимодействие с формой"
      if (!interacted) {
        trackFirstInteractionForm();

        setInteracted(true);
      }
    },
    [state, interacted],
  );

  const submitFeedback = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();

      const isValid = formValidator();

      if (isValid) {
        const { name, phone, email, comment } = state;
        dispatch(sendFeedback({ name, phone, email, comment }));
      }
    },
    [dispatch, formValidator, state],
  );

  return (
    <Form {...state} isLoading={isLoading} isSendError={isSendError} setField={setField} sendForm={submitFeedback} />
  );
};

FeedbackFormContainer.displayName = 'FeedbackFormContainer';
